import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { closeSnackbar } from "../actions/snackbar"

function Snackbar({ snackbar, closeSnackbar }) {
  useEffect(() => {
    let timeout;

    if (snackbar.display) {
      timeout = setTimeout(function () {
        closeSnackbar()
      }, 4000)
    }

    return () => {
      clearTimeout(timeout)
    }
  }, [closeSnackbar, snackbar]);

  return (
    <div className="snackbar">
      {
        snackbar.display &&
        <div className={`snackbar-body d-flex align-baseline ${snackbar.status === "success" && "primary"} ${snackbar.status === "error" && "secondary"}`}>
          <div>{snackbar.text}</div>

          <button style={{ backgroundColor: snackbar.status === "error" ? '#ff0000' : '#487118' }} className="snackbar-button ml-3" onClick={() => closeSnackbar()}>X</button>
        </div>
      }
    </div>
  )
}

const mapStateToProps = state => ({
  snackbar: state.snackbar
})

export default connect(mapStateToProps, { closeSnackbar })(Snackbar)